/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calm_Pale_Otter_DriftInputs */

const en_calm_pale_otter_drift = /** @type {(inputs: Calm_Pale_Otter_DriftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading…`)
};

const de_calm_pale_otter_drift = /** @type {(inputs: Calm_Pale_Otter_DriftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird geladen…`)
};

/**
* | output |
* | --- |
* | "Loading…" |
*
* @param {Calm_Pale_Otter_DriftInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const calm_pale_otter_drift = /** @type {((inputs?: Calm_Pale_Otter_DriftInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calm_Pale_Otter_DriftInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calm_pale_otter_drift(inputs)
	return de_calm_pale_otter_drift(inputs)
});